import React, { useState } from "react";
import TimeInput from "../../../parts/inputs/TimeInput";
import Modal from "../../../parts/modal-new";
import { useTranslation } from "react-i18next";

const RestTimesModal = ({ userToBindInformation, notAbleToEdit }) => {
  const { t } = useTranslation("dashboard");
  const [isOpen, setIsOpen] = useState(false);
  const handleOpenModal = () => {
    setIsOpen(!isOpen);
  };
  return (
    <>
      <button
        disabled={notAbleToEdit}
        data-button-type="tertiary"
        onClick={(e) => {
          e.preventDefault();
          handleOpenModal();
        }}
      >
        {t("restTimesModal.custom")}
      </button>
      <Modal
        title={t("restTimesModal.title")}
        className={isOpen ? "custom-rest-modal" : "hidden!"}
        onClose={() => setIsOpen(false)}
      >
        <div className="body">
          {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((timeField) => {
            const defaultValue =
              timeField === "default"
                ? userToBindInformation?.restTime?.default
                : userToBindInformation?.restTime?.reps &&
                  userToBindInformation?.restTime?.reps[`rep${timeField}`];
            return (
              <div
                className="time-input-wrapper"
                key={`time-setting-${timeField}`}
              >
                <label>
                  {" "}
                  {timeField === 12
                    ? t("restTimesModal.rep12Plus")
                    : t("restTimesModal.repLabel", { count: timeField })}{" "}
                </label>
                <TimeInput
                  defaultValue={defaultValue}
                  name={timeField}
                  notAbleToEdit={notAbleToEdit}
                />
              </div>
            );
          })}
        </div>
        <footer>
          <button
            data-button-type="secondary"
            data-action="cancel"
            onClick={handleOpenModal}
          >
            {t("common:cancel")}
          </button>
          <button data-button-type="primary" onClick={handleOpenModal}>
            {t("common:save")}
          </button>
        </footer>
      </Modal>
    </>
  );
};

export default RestTimesModal;
